// import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import i18n from '@BUP/configs/i18n'
import AlertComponent from '@BUP/components/Generics/Alert'

const AuthErrorAlert = ({ error }) => {
  const [t] = useTranslation('translation', { i18n })
  let message
  switch (error.code) {
    case 'auth/user-not-found':
      message = t('common.resources.session.actions.create.failure', { context: 'not-found' })
      break
    case 'auth/wrong-password':
      message = t('common.resources.session.actions.create.failure', { context: 'wrong-password' })
      break
    default:
      message = error.message
  }
  return <AlertComponent message={message} type='error' />
}

export default AuthErrorAlert
